var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.268,
    height: 43.268,
    viewBox: "0 0 43.268 43.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_refresh-2",
    "data-name": "vuesax/linear/refresh-2",
    transform: "translate(-364 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh-2",
    transform: "translate(364 316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.11,14.44v9.014",
    transform: "translate(4.497 15.198)",
    fill: "none",
    stroke: "#1383d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M36.056,18.028A18.035,18.035,0,0,1,18.028,36.056C8.077,36.056,2,26.033,2,26.033H10.15M0,18.028A17.989,17.989,0,0,1,18.028,0C30.053,0,36.056,10.024,36.056,10.024m0,0V1.01m0,9.014h-8",
    transform: "translate(3.606 3.606)",
    fill: "none",
    stroke: "#1383d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H43.268V43.268H0Z",
    transform: "translate(43.268 43.268) rotate(180)",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_gallery",
    "data-name": "vuesax/linear/gallery",
    transform: "translate(378.388 330.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1.208,11.25l1.609-.525L4.46,9.607a2.352,2.352,0,0,1,2.308,0c1.329.664,1.4.07,3.007-1.329s2.343-1.5,3.532.35c-.035-1.958,0-3.812,0-3.812s-.172-3.672-3.532-3.672H4.7S1.033.754,1.033,5.13,1.208,11.25,1.208,11.25Z",
    fill: "#d9efff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M4.227,12.076H7.85c3.019,0,4.227-1.208,4.227-4.227V4.227C12.076,1.208,10.869,0,7.85,0H4.227C1.208,0,0,1.208,0,4.227V7.85C0,10.869,1.208,12.076,4.227,12.076Z",
    transform: "translate(1.208 1.208)",
    fill: "none",
    stroke: "#1383d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M2.415,1.208A1.208,1.208,0,1,1,1.208,0,1.208,1.208,0,0,1,2.415,1.208Z",
    transform: "translate(4.227 3.623)",
    fill: "none",
    stroke: "#1383d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,4.2l2.977-2a1.36,1.36,0,0,1,1.594.085l.2.175a1.346,1.346,0,0,0,1.7,0L8.985.3a1.346,1.346,0,0,1,1.7,0l.984.845",
    transform: "translate(1.612 7.244)",
    fill: "none",
    stroke: "#1383d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0H14.492V14.492H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProcess);
export default __webpack_public_path__ + "static/media/img-process.c2fc6489637bb2d02b78ead99f526835.svg";
export { ForwardRef as ReactComponent };